<template>
    <div class="banner-frame">

    </div>
</template>

<script>
    export default {
        name: "banner"
    }
</script>

<style scoped lang="scss">
    .banner-frame{
        min-width: 1200px;
        background: url("../../../assets/images/join/join-banner.png") no-repeat center center;
        height: 400px;
        margin: 0 auto;
    }
</style>
